import {cloneDeep as _cloneDeep} from 'lodash';
import DistrictModel from "@/models/DistrictModel"
const DistrictsModule = {
    namespaced: true,
    state: () => ({
        district: _cloneDeep(DistrictModel),
        districts: [],
    }),
    getters: {
        getDistrict (state) {
            return state.district
        },
        getDistricts(state) {
            return state.districts
        },
    },
    mutations: {
        setDistrict (state, payload) {
            state.district = payload
        },
        setDistricts(state, payload) {
            state.districts = payload
        },
    },
    actions: {
        setDistrict (context, payload) {
            context.commit('setDistrict', payload);
        },
        setDistricts(context, payload) {
            context.commit('setDistricts', payload);
        },
    },
}

export default DistrictsModule;
